module.exports = __webpack_public_path__ + "static/media/crystal_palace.92dbee3b.png";